"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stateSchema = exports.accountStateSchema = void 0;
const yup_lib_1 = __importDefault(require("../yup-lib"));
const data_1 = require("@citibot/data");
const stateType = [...data_1.states];
exports.accountStateSchema = yup_lib_1.default.string().nullable().oneOf(data_1.states).required().label('State');
exports.stateSchema = yup_lib_1.default.object().shape({
    state: yup_lib_1.default.string().oneOf(data_1.states).required()
});
